export const auxiliaryComponents = {
    BROWSER: 'browser',
    IMAGE: 'image',
};
